const lockCar = {
  state: {
    // 租赁替换单首页筛选数据
    lockCarFilter: {
      plate_number: {},
      vin_code: {},
      order_type: '',
      back_rent_status: '',
      dri_lic_remind_status: '',
      expired_insurance_status: '',
      humanLock: [],
      lock_command: ''
    },
    isLockCar: false
  },
  mutations: {
    SET_lockCarFilter(state, payload) {
      state.lockCarFilter = payload
    },
    SET_Filter(state, payload) {
      state.isLockCar = payload
    }
  }
}

export default lockCar



// WEBPACK FOOTER //
// ./src/store/model/lockCar.js